module.exports = __webpack_public_path__ + "static/media/map-pin.05d1ea63.png";